import { render, staticRenderFns } from "./PaymentCompleteInfo.vue?vue&type=template&id=40276ce4&scoped=true&"
import script from "./PaymentCompleteInfo.vue?vue&type=script&lang=js&"
export * from "./PaymentCompleteInfo.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCompleteInfo.vue?vue&type=style&index=0&id=40276ce4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40276ce4",
  null
  
)

export default component.exports